import { create } from 'zustand';

type ProvisionalLineSaleStore = {
  provisionalLine: number | null;
  setProvisionalLine(value: number | null): void;
};

export const useProvisionalLineSaleStore = create<ProvisionalLineSaleStore>(
  (set) => ({
    provisionalLine: null,
    setProvisionalLine(value: number | null) {
      set((state) => ({ ...state, provisionalLine: value }));
    },
  }),
);
